import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const style = css`
  vertical-align: middle;

  :focus {
    outline: none;
  }

  svg {
    transition: fill 200ms ease-in-out;
  }

  :hover svg,
  :focus svg {
    fill: ${theme.colors.primary50};
  }
`;

export const InfoStyles = {
  infoStyle: style,
};
